export default "__VITE_ASSET__DsV1$i0i__"